import { buildProps } from '@sgui-plus/utils/props'
import type { ExtractPropTypes } from 'vue'
import type Badge from './badge.vue'

export const badgeProps = buildProps({
  value: {
    type: [String, Number],
    default: '',
  },
  overflowCount: {
    type: Number,
    default: 99,
  },
  dot: Boolean,
  type: {
    type: String,
    values: ['primary', 'success', 'warning', 'info', 'danger'],
    default: 'danger',
  },
  color: {
    type: String,
    default: ''
  },
  hidden: {
    type: Boolean,
    default: false
  },
  offset: Array
} as const)
export type BadgeProps = ExtractPropTypes<typeof badgeProps>

export type BadgeInstance = InstanceType<typeof Badge>
